module.exports = __webpack_public_path__ + "static/img/b56150eb-5caa-4385-b907-373e97ddb2ff.8286231.svg";